import React from 'react';

export const AuthContext = React.createContext(
    {
        logged_in_entity_role: null,
        setLoggedInEntityRole: () => {},
    }
);